module.exports = __webpack_public_path__ + "378f9c9d91246832ed4f813aa05139a6.png";